import Vue from 'vue'
import Router from 'vue-router'

import constants from './constants.js'

import Home from '@/components/page/Home'

import Generic from '@/components/page/Generic'
import Blog from '@/components/page/Blog'
import Post from '@/components/page/Post'
import Listing from '@/components/page/Listing'
import Events from '@/components/page/Events'
import Event from '@/components/page/Event'
import Vacancies from '@/components/page/Vacancies'
import Contact from '@/components/page/Contact'

import Login from '@/components/page/Login'
import loginForgot from '@/components/page/login/Forgot'
import loginReset from '@/components/page/login/Reset'
import Logout from '@/components/page/Logout'

import joinCustomer from '@/components/page/join/Customer'
// import joinBusiness from '@/components/page/join/Business'

import Dashboard from '@/components/page/Dashboard'

import Search from '@/components/page/Search'

import Business from '@/components/page/Business'
import businessReviews from '@/components/page/business/Reviews'
import businessReviewsWrite from '@/components/page/business/reviews/Write'
import businessBlog from '@/components/page/business/Blog'
import businessPrices from '@/components/page/business/Prices'
import businessPhotos from '@/components/page/business/Photos'
import businessOffers from '@/components/page/business/Offers'
import businessAbout from '@/components/page/business/About'
import businessContact from '@/components/page/business/Contact'
import businessBookings from '@/components/page/business/Bookings'
import businessPeople from '@/components/page/business/People'

import Account from '@/components/page/Account'
import accountProfileAbout from '@/components/page/account/profile/About'
import accountProfileBlog from '@/components/page/account/profile/Blog'
import accountProfileOffers from '@/components/page/account/profile/Offers'
import accountProfileEvents from '@/components/page/account/profile/Events'
import accountProfilePeople from '@/components/page/account/profile/People'
import accountProfilePhotos from '@/components/page/account/profile/Photos'
import accountProfileVacancies from '@/components/page/account/profile/Vacancies'
import accountProfilePrices from '@/components/page/account/profile/Prices'
import accountProfileBookings from '@/components/page/account/profile/Bookings'
import accountProfileOwner from '@/components/page/account/profile/Owner'
import accountProfileContact from '@/components/page/account/profile/Contact'
import accountProfilePassword from '@/components/page/account/profile/Password'
import accountComplete from '@/components/page/account/Complete'
import accountOffers from '@/components/page/account/Offers'
import accountEvents from '@/components/page/account/Events'
import accountReviews from '@/components/page/account/Reviews'
import accountRefer from '@/components/page/account/Refer'
import accountIncentives from '@/components/page/account/Incentives'
import accountResources from '@/components/page/account/Resources'
import accountSuppliers from '@/components/page/account/Suppliers'
import accountAdverts from '@/components/page/account/Adverts'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{ name: 'Home', path: '/', component: Home, meta: { page: 'home' } },
		{ path: '/home', redirect: { name: 'Home' } },
		
        { name: 'Listing', path: '/list-your-business', component: Listing, meta: { page: 'list-your-business', requireLogout: true } },

		{ name: 'Login', path: '/login/customer', component: Login, meta: { context: constants.context.customer, page: 'login', requireLogout: true } },
		{ name: 'Login/Reset', path: '/reset/:key', component: loginReset, meta: { page: 'login', requireLogout: false } },
		{ name: 'Login/Customer', path: '/login/customer', component: Login, meta: { context: constants.context.customer, page: 'login', requireLogout: true } },
		{ name: 'Login/Customer/Twitter', path: '/login/customer/twitter', component: Login, meta: { context: constants.context.customer, page: 'login', requireLogout: true, twitter: true } },
		{ name: 'Login/Customer/Facebook', path: '/login/customer/facebook', component: Login, meta: { context: constants.context.customer, page: 'login', requireLogout: true, facebook: true } },
		{ name: 'Login/Business', path: '/login/business', component: Login, meta: { context: constants.context.business, page: 'login', requireLogout: true } },
		{ name: 'Login/Customer/Forgot', path: '/login/customer/forgot', component: loginForgot, meta: { context: constants.context.customer, page: 'login', requireLogout: true } },
		{ name: 'Login/Business/Forgot', path: '/login/business/forgot', component: loginForgot, meta: { context: constants.context.business, page: 'login', requireLogout: true } },

		{ name: 'Logout', path: '/logout', component: Logout, page: 'logout', requireLogin: true },

		{ name: 'Register', path: '/join', component: joinCustomer, meta: { context: constants.context.customer, page: 'join' } },
		{ name: 'Register/Customer', path: '/join/customer', component: joinCustomer, meta: { context: constants.context.customer, page: 'join' } },
		/*{ name: 'Register/Business', path: '/join/business', component: joinBusiness, meta: { context: constants.context.business, page: 'join' } },
		{ name: 'Register/Business/Success', path: '/join/business/success', component: joinBusiness, meta: { context: constants.context.business, page: 'join', success: true } },
		{ name: 'Register/Business/Cancel', path: '/join/business/cancel', component: joinBusiness, meta: { context: constants.context.business, page: 'join', cancel: true } },*/

        { name: 'Dashboard', path: '/dashboard', component: Dashboard, meta: { page: 'dashboard' } },
        
		{ 
            path: '/business/:slug', 
            component: Business, 
            meta: { page: 'business', root: true },
            children: [
                {
                    path: '',
                    name: 'Business',
                    component: businessReviews,
                    meta: { page: 'business', root: true }
                },
                {
                    path: 'reviews',
                    name: 'Business/Reviews',
                    component: businessReviews,
                    meta: { page: 'business' },
                },
                {
                    path: 'reviews/write',
                    name: 'Business/Reviews/Write',
                    component: businessReviewsWrite,
                    meta: { page: 'business' },
                },
                {
                    path: 'reviews/:hash',
					name: 'Business/Reviews/Share',
                    component: businessReviews,
                    meta: { page: 'business' }
                },
                {
                    path: 'prices',
                    name: 'Business/Prices',
                    component: businessPrices,
                    meta: { page: 'business' }
                },
                {
                    path: 'bookings',
                    name: 'Business/Bookings',
                    component: businessBookings,
                    meta: { page: 'business' }
                },
                {
                    path: 'photos',
					name: 'Business/Photos',
                    component: businessPhotos,
                    meta: { page: 'business' }
                },
                {
                    path: 'photos/:hash',
					name: 'Business/Photos/Share',
                    component: businessPhotos,
                    meta: { page: 'business' }
                },
                {
                    path: 'offers',
                    name: 'Business/Offers',
                    component: businessOffers,
                    meta: { page: 'business' }
                },
                {
                    path: 'people',
                    name: 'Business/People',
                    component: businessPeople,
                    meta: { page: 'business' }
                },
                {
                    path: 'about',
                    name: 'Business/About',
                    component: businessAbout,
                    meta: { page: 'business' }
                },
                {
                    path: 'blog',
                    name: 'Business/Blog',
                    component: businessBlog,
                    meta: { page: 'business' }
                },
                {
                    path: 'contact',
                    name: 'Business/Contact',
                    component: businessContact,
                    meta: { page: 'business' }
                }
            ]
        },

        { name: 'Search', path: '/search', component: Search, meta: { page: 'search' } },

		{
			path: '/account',
			component: Account,
			meta: {
				requireLogin: true
			},
			children: [
				{
					path: '',
					name: 'Default',
					component: accountProfileAbout,
					meta: { page: 'account' }
				},
				{
					path: 'complete',
					name: 'Account/Complete',
					component: accountComplete,
					meta: {
						default: 'Account/Complete',
						page: 'account'
					}
				},
				{
					path: 'profile',
					name: 'Account/Profile',
					component: accountProfileAbout,
					meta: {
						default: 'Account/Profile/About',
						page: 'account'
					}
				},
				{
					path: 'profile/about',
					name: 'Account/Profile/About',
					component: accountProfileAbout,
					meta: {
						parent: 'Account/Profile',
						page: 'account'
					}
				},
				{
					path: 'profile/blog',
					name: 'Account/Profile/Blog',
                    component: accountProfileBlog,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/blog/page/:page',
					name: 'Account/Profile/Blog/Pagination',
                    component: accountProfileBlog,
					meta: {
						default: 'Account/Profile/Blog',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/offers',
					name: 'Account/Profile/Offers',
                    component: accountProfileOffers,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/offers/page/:page',
					name: 'Account/Profile/Offers/Pagination',
                    component: accountProfileOffers,
					meta: {
						default: 'Account/Profile/Offers',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/events',
					name: 'Account/Profile/Events',
                    component: accountProfileEvents,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/events/page/:page',
					name: 'Account/Profile/Events/Pagination',
                    component: accountProfileEvents,
					meta: {
						default: 'Account/Profile/Events',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/people',
					name: 'Account/Profile/People',
                    component: accountProfilePeople,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/people/page/:page',
					name: 'Account/Profile/People/Pagination',
                    component: accountProfilePeople,
					meta: {
						default: 'Account/Profile/People',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/photos',
					name: 'Account/Profile/Photos',
                    component: accountProfilePhotos,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/photos/page/:page',
					name: 'Account/Profile/Photos/Pagination',
                    component: accountProfilePhotos,
					meta: {
						default: 'Account/Profile/Photos',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/vacancies',
					name: 'Account/Profile/Vacancies',
                    component: accountProfileVacancies,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/vacancies/page/:page',
					name: 'Account/Profile/Vacancies/Pagination',
                    component: accountProfileVacancies,
					meta: {
						default: 'Account/Profile/Vacancies',
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/prices',
					name: 'Account/Profile/Prices',
                    component: accountProfilePrices,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/bookings',
					name: 'Account/Profile/Bookings',
                    component: accountProfileBookings,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/contact',
					name: 'Account/Profile/Contact',
					component: accountProfileContact,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireCustomer: true
					}
				},
				{
					path: 'profile/owner',
					name: 'Account/Profile/Owner',
					component: accountProfileOwner,
					meta: {
						parent: 'Account/Profile',
						page: 'account',
						requireBusiness: true
					}
				},
				{
					path: 'profile/password',
					name: 'Account/Profile/Password',
					component: accountProfilePassword,
					meta: {
						parent: 'Account/Profile',
						page: 'account'
					}
				},
				{
					path: 'reviews',
					name: 'Account/Reviews',
					component: accountReviews,
					meta: { 
						page: 'account'
					}
				},
				{
					path: 'offers',
					name: 'Account/Offers',
					component: accountOffers,
					meta: { 
						page: 'account',
						requireCustomer: true
					}
				},
				{
					path: 'events',
					name: 'Account/Events',
					component: accountEvents,
					meta: { 
						page: 'account',
						requireCustomer: true
					}
				},
				{
					path: 'refer',
					name: 'Account/Refer',
					component: accountRefer,
					meta: { 
						page: 'account',
						requireCustomer: true 
					}
				},
				{
					path: 'incentives',
					name: 'Account/Incentives',
					component: accountIncentives,
					meta: { 
						page: 'account',
						requireBusiness: true 
					}
				},
				{
					path: 'resources',
					name: 'Account/Resources',
					component: accountResources,
					meta: { 
						page: 'account',
						requireBusiness: true 
					}
				},
				{
					path: 'suppliers',
					name: 'Account/Suppliers',
					component: accountSuppliers,
					meta: { 
						page: 'account',
						requireBusiness: true 
					}
				},
				{
					path: 'adverts',
					name: 'Account/Adverts',
					component: accountAdverts,
					meta: { page: 'account', requireBusiness: true }
				},
				{
					path: 'adverts/success',
					name: 'Account/Adverts/Success',
					component: accountAdverts,
					meta: { page: 'account', success: true, requireBusiness: true }
				},
				{
					path: 'adverts/cancel',
					name: 'Account/Adverts/Cancel',
					component: accountAdverts,
					meta: { page: 'account', cancel: true, requireBusiness: true }
				}
			]
        },
        
        { name: 'Blog', path: '/blog', component: Blog, meta: { page: 'blog' } },
        { name: 'Events', path: '/events', component: Events, meta: { page: 'events' } },
        { name: 'Vacancies', path: '/vacancies', component: Vacancies, meta: { page: 'vacancies' } },
        { name: 'Blog/Post', path: '/blog/:slug', component: Post },
        { name: 'Events/Event', path: '/events/:slug', component: Event },
        { name: 'Contact', path: '/contact', component: Contact, meta: { page: 'contact' } },
        { name: '404', path: '/404', component: Generic, meta: { page: 'page-not-found' } },
        { name: 'Generic', path: '/:slug', component: Generic },
        { path: '*', component: Generic, meta: { page: 'page-not-found' } }

	]
})